import 'firebase/firestore'
import firebase from 'firebase/app'
import config from './config'

firebase.initializeApp(config)

export const firestore = firebase.firestore()
